export { default } from "./DetailPopover";
export * from "./DetailPopover.types";
